import { c as _c } from "react/compiler-runtime";
import { Toast } from '@base-ui/react/toast';
import { css } from '@repo/pandacss/css';
import { CloseIcon } from '@repo/ui/icons/CloseIcon';
import { toastRecipe } from './styles';
import { ToastIcon } from './ToastIcon';
import { getSafeToastType } from './utils';
export function ToastList() {
  const $ = _c(4);
  const {
    toasts
  } = Toast.useToastManager();
  let t0;
  if ($[0] !== toasts) {
    t0 = toasts.map(_temp);
    $[0] = toasts;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = <>{t0}</>;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}
function _temp(toast) {
  return <Toast.Root key={toast.id} toast={toast} className={toastRecipe({
    type: getSafeToastType(toast.type)
  })}><ToastIcon type={getSafeToastType(toast.type)} /><Toast.Title className={css({
      color: "neutral.darkest",
      textStyle: "body.small",
      lineHeight: "body",
      fontWeight: "default"
    })} /><Toast.Close className={css({
      flexShrink: "[0]",
      bg: "[transparent]",
      border: "none",
      color: "neutral.darker",
      cursor: "pointer",
      rounded: "sm",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      _hover: {
        bg: "neutral.lightest"
      }
    })} aria-label="Dismiss"><CloseIcon /></Toast.Close></Toast.Root>;
}